import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://cargo-urgent.preview.emergentagent.com';
const OG_IMAGE = 'https://customer-assets-m6fa6gv7.emergentagent.net/job_cargo-urgent/artifacts/esv8b4gm_AOG%20ATC%20.png';

const SEO = ({ title, description, path = '/' }) => {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
};

export default SEO;
